<template>
  <div>
    <Banner :classType="1" />
    <Menu />
    <div
      class="pageTitle wow animate__slideInUp"
      :class="{ titleEn: lang == 'en' }"
    >
      <h2>公司领导</h2>
      <p>MANAGEMENT</p>
    </div>

    <!-- :data-wow-delay="`${idx / 10}s`"  -->
    <div class="wrap leadersBox wow animate__slideInUp">
      <ul class="leaderLst">
        <li :key="idx" v-for="(item, idx) in list">
          <el-image
            class="leaderImg"
            :src="item.PicUrl"
            :preview-src-list="imgList"
            fit="cover"
          ></el-image>
          <div class="info">
            <h3>{{ item.Name }}</h3>
            <p>{{ item.Summary }}</p>
          </div>
        </li>
      </ul>

      <Pagination @pageChange="getData" :PagingInfo="PagingInfo" />
    </div>
  </div>
</template>

<script>
import Banner from "@/views/components/Banner";
import Menu from "./Menu.vue";
import Pagination from "@/views/components/Pagenation";
import { WOW } from "wowjs";
import cookie from "cookiejs";

export default {
  data() {
    return {
      list: [],
      PagingInfo: {},
      imgList: [],
      lang: "zh",
    };
  },
  components: {
    Banner,
    Menu,
    Pagination,
  },
  created() {
    this.lang = cookie.get("lang");
  },
  methods: {
    getData(page, type) {
      this.$api
        .leader({
          CurrentPage: page,
          ItemsPerPage: 10,
        })
        .then((res) => {
          const { Leaders, PagingInfo } = res.Value;
          this.list = Leaders;
          let imgArray = [];
          Leaders.map((item) => {
            imgArray.push(item.PicUrl);
          });
          this.imgList = imgArray;
          this.PagingInfo = PagingInfo;
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                offset: 100,
                live: false,
              }).init();
            });
          }
        });
    },
  },
  mounted() {
    this.getData(1, "first");
  },
};
</script>

<style lang="scss">
.leadersBox {
  padding:0！important;
}
.leaderLst {
  padding-top:50px;
  border-bottom: 1px solid #bfbfbf;
  margin-bottom: 50px;
  li {
    padding: 20px 0;
    border-top: 1px solid #bfbfbf;
    display: flex;
    align-items: center;
    // flex-direction: column;
    .leaderImg {
      min-width: 150px;
      flex-shrink: 0;
    }
    h3 {
      margin-bottom: 10px;
    }
    .info {
      margin-left: 30px;
      // flex-shrink: 0;
    }
    &:hover {
      background: #f9f9f9;
    }
  }
}
</style>